module.exports = __webpack_public_path__ + "img/osveschenie.b2e89384.svg";